import {writable} from 'svelte/store';

const ALERTS = {
    NOTHING: null,
    CONFIRM: 1,
    WARNING: 2,
    ERROR: 3,
}

const {set, update, subscribe} = writable({
    type: ALERTS.NOTHING,
    prompt: null,
    yesCallback: null,
    noCallback: null,
});

const displayMessage = (type, prompt, yesCallback = null, noCallback = null) => {
    update(state => {
        state.type = type;
        state.prompt = prompt.replaceAll("\n", "<br>");
        state.yesCallback = yesCallback;
        state.noCallback = noCallback;
        return state;
    })
}

const appAlert = {
    set, update, subscribe,
    confirm: (prompt, yesCallback = null, noCallback = null) => {
        displayMessage(ALERTS.CONFIRM, prompt, yesCallback, noCallback);
    },
    warning: (prompt, yesCallback = null, noCallback = null) => {
        displayMessage(ALERTS.WARNING, prompt, yesCallback, noCallback);
    },
    error: (prompt, yesCallback = null) => {
        displayMessage(ALERTS.ERROR, prompt, yesCallback);
    },
    hide: () => {
        update(state => {
            state.type = ALERTS.NOTHING;
            state.prompt = null;
            state.yesCallback = null;
            state.noCallback = null;
            return state;
        })
    }
}
export default appAlert;

export {ALERTS};